var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('UserHeadline',{attrs:{"title":_vm.$t('OrderInfo.title'),"icon":"info"}}),_c('div',{staticClass:"page-content__container"},[_c('YourOrder'),_c('OrderHistory')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }